import { Component, inject } from '@angular/core';
import {FinishBoxComponent} from "../../../common/finish-box/finish-box.component";
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";
import { NgOptimizedImage } from "@angular/common";
import {RouterLink} from "@angular/router";
import {LocaleService} from "../../../../locale/locale.service";
import { ColoredBackgroundComponent } from '../../../common/colored-background/colored-background.component';

@Component({
  selector: 'app-what-is-covered',
  imports: [
    ColoredBackgroundComponent,
    FinishBoxComponent,
    FooterComponent,
    HeaderComponent,
    RouterLink
  ],
  templateUrl: './what-is-covered.component.html',
  styleUrl: './what-is-covered.component.css'
})
export class WhatIsCoveredComponent {
  locale = inject(LocaleService);
}
